import React from 'react';
import { injectIntl, IntlShape } from 'react-intl';

import { Config } from 'containers/AppContainer/typings';
import { Expertise } from 'containers/common/LegalProceedings/JudgementAdd/Forms/JudgementAddPrononcings/typings';
import ExpertiseType from 'containers/common/LegalProceedings/JudgementAdd/Recap/Pronouncing/Expertise/ExpertiseType';
import ExpertiseVictim from 'containers/common/LegalProceedings/JudgementAdd/Recap/Pronouncing/Expertise/Victim';
import ExpertiseVehicule from 'containers/common/LegalProceedings/JudgementAdd/Recap/Pronouncing/Expertise/Vehicule';
import ExpertiseVictims from 'containers/common/LegalProceedings/JudgementAdd/Recap/Pronouncing/Expertise/Victims';
import ExpertiseVehicules from 'containers/common/LegalProceedings/JudgementAdd/Recap/Pronouncing/Expertise/Vehicules';
import { EXPERTISE_FIELD } from 'containers/common/LegalProceedings/JudgementAdd/Forms/JudgementAddPrononcings/constants';
import { get } from 'lodash';

export interface ExpertiseRecapProps {
  intl: IntlShape;
  expertiseList: Config[];
  expertise: Expertise;
  index: number;
  sagisVictimInfo: any;
  sagisOpposingParties: any;
  isBasicManagement?: boolean;
}

const ExpertiseRecap: React.FC<ExpertiseRecapProps> = (props): JSX.Element => {
  const { expertise, index } = props;
  return (
    <ExpertiseType
      expertiseId={expertise[EXPERTISE_FIELD.EXPERTISE_ID]}
      expertiseList={props.expertiseList}
      index={index}
    >
      <ExpertiseVictims
        victims={get(expertise, 'victims', []).filter(
          (item: any) => !get(item, 'expertise.isDeleted'),
        )}
      >
        {get(expertise, 'victims', [])
          .filter((item: any) => !get(item, 'expertise.isDeleted'))
          .map((victim: any) => (
            <ExpertiseVictim
              key={victim.id}
              victim={victim}
              displayExpertise={true}
              sagisVictimInfo={props.sagisVictimInfo}
              isBasicManagement={props.isBasicManagement}
            />
          ))}
      </ExpertiseVictims>
      <ExpertiseVehicules
        vehicules={get(expertise, 'vehicules', []).filter(
          (item: any) => !get(item, 'expertise.isDeleted'),
        )}
      >
        {get(expertise, 'vehicules', [])
          .filter((item: any) => !get(item, 'expertise.isDeleted'))
          .map(vehicule => (
            <ExpertiseVehicule
              key={vehicule.id}
              vehicule={vehicule}
              displayExpertise={true}
              sagisOpposingParties={props.sagisOpposingParties}
              isBasicManagement={props.isBasicManagement}
            ></ExpertiseVehicule>
          ))}
      </ExpertiseVehicules>
    </ExpertiseType>
  );
};

export default injectIntl(ExpertiseRecap);
